import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Signup from './components/Signup';
import Login from './components/Login';
import Dashboard from './foundation/Dashboard';
import IncidentLogForm from './foundation/IncidentLogForm';
import EmployeeRoster from './foundation/EmployeeRoster';
import HarassmentEvidenceWorkspace from './foundation/HarassmentEvidenceWorkspace';
import TrainingLog from './foundation/TrainingLog';
import About from './components/About';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import ComplianceHub from './foundation/ComplianceHub';
import PricingPage from './foundation/PricingPage';
import ExposureCheck from './foundation/ExposureCheck';
import Resources from './foundation/Resources';
import ProtectedRoute from './components/ProtectedRoute';
import SiteMetadata from './components/SiteMetadata';
import WorkspaceNav from './components/WorkspaceNav';
import PropertyManagementPage from './components/PropertyManagementPage';
import './App.css';


export function MainApp() {
  const location = useLocation();
  const requestedView = location.state?.workspaceView;
  const [view, setView] = React.useState(
    ['dashboard', 'employees', 'form'].includes(requestedView) ? requestedView : 'dashboard'
  );

  return (
    <div className="App">
      <WorkspaceNav activeView={view} onSelectView={setView} />

      {view === 'dashboard' && (
        <Dashboard
          onLogIncident={() => setView('form')}
        />
      )}
      {view === 'employees' && <EmployeeRoster />}
      {view === 'form' && <IncidentLogForm />}
    </div>
  );
}


function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <SiteMetadata />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/property-management" element={<PropertyManagementPage />} />
        <Route path="/exposure-check" element={<ExposureCheck />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/signup/success" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/compliance-hub" element={<ProtectedRoute><ComplianceHub /></ProtectedRoute>} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <MainApp />
            </ProtectedRoute>
          }
        />
        <Route
          path="/training"
          element={
            <ProtectedRoute>
              <TrainingLog />
            </ProtectedRoute>
          }
        />
        <Route
          path="/harassment-training"
          element={
            <ProtectedRoute>
              <div className="App">
                <WorkspaceNav activeView="harassment" />
                <HarassmentEvidenceWorkspace />
              </div>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
